import React, { useRef, useState } from 'react';
import logo from './images/Junior-Golf-365.png';
import golf from './images/golf.png';
import './App.css';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';



firebase.initializeApp({
    apiKey: "AIzaSyB60CA1JEhHZd19-wchsbR83poTnWZyI1c",
    authDomain: "junior-golf-365-chat-app.firebaseapp.com",
    databaseURL: "https://junior-golf-365-chat-app.firebaseio.com",
    projectId: "junior-golf-365-chat-app",
    storageBucket: "junior-golf-365-chat-app.appspot.com",
    messagingSenderId: "1006029340342",
    appId: "1:1006029340342:web:51a7dfb4708afc51487017",
    measurementId: "G-JX1TFSGBY2"
})

const auth = firebase.auth();
const firestore = firebase.firestore();
const analytics = firebase.analytics();


function App() {

    const [user] = useAuthState(auth);

    return (<div className="App" >
        <header>
            <
                img id="logo"
                src={logo}
            />

            <
                SignOut />
        </header>

        <section> {user ? < ChatRoom /> : < SignIn />} </section>

    </div>
    );
}


function SignIn() {

    const signInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider);
    }

    return (<>
        <button className="sign-in" onClick={signInWithGoogle} > Sign in with Google </button>
        <p className="notice" > Welcome to the Junior Golf 365 Community. <br/>Enjoy the Updates, Information & Relationships we are Building.</p>
        <p className="credits"> Made with <span className="love">❤</span> by <a href="mailto:webbotbuilders@gmail.com" className="dev-by">Web Bot Builders</a></p>
    </>
    )

}

function SignOut() {
    return auth.currentUser && (<button className="sign-out" onClick={() => auth.signOut()
    } > Sign Out </button>
    )
}

function ChatRoom() {
    const dummy = useRef();
    const messagesRef = firestore.collection('messages');
    const query = messagesRef.orderBy('createdAt').limit(25);

    const [messages] = useCollectionData(query, { idField: 'id' });

    const [formValue, setFormValue] = useState('');


    const sendMessage = async (e) => {
        e.preventDefault();

        const { uid, photoURL } = auth.currentUser;

        await messagesRef.add({
            text: formValue,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            uid,
            photoURL
        })

        setFormValue('');
        dummy.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (<>
        <main>

            {messages && messages.map(msg => < ChatMessage key={msg.id} message={msg} />)}

            <span ref={dummy} > </span>

        </main>

        <form onSubmit={sendMessage}>

            <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="Post Results or Ask a Question to Coach Chris" />

            <button type="submit" disabled={!formValue} id="sub-btn" > < img src={golf} /></button >

        </form>
    </>
    )
}



function ChatMessage(props) {
    const { text, uid, photoURL } = props.message;

    const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

    return (<>
        <div className={`message ${messageClass}`}>
            <img id="avatar" src={photoURL || 'https://api.adorable.io/avatars/23/abott@adorable.png'} />
            <p id= "chats"> {text} </p>
        </div>
    </>
    )
}


export default App;